<template>
  <div class="col-12 page_content_area">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="page_title">實習紀錄</div>
          <div class="page_subtitle">{{ subtitle }}</div>
          <div class="portlet_wrapper">
            <div class="view_type_tab">
              <div :class="activeSegment == '學生相關表單' ? 'active' : null" @click="activeSegment = '學生相關表單'">學生相關表單</div>
              <div :class="activeSegment == '其他文件上傳' ? 'active' : null" @click="activeSegment = '其他文件上傳'">其他文件上傳</div>
            </div>
            <select class="view_type_select" v-model="activeSegment">
              <option value="學生相關表單">學生相關表單</option>
              <option value="其他文件上傳">其他文件上傳</option>
            </select>
            <div class="cnt_block">
              <student-detail-form-list
                class="segment_area"
                :class="activeSegment == '學生相關表單' ? 'active' : null"
              />
              <student-detail-file-upload
                class="segment_area"
                :class="activeSegment == '其他文件上傳' ? 'active' : null"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import StudentDetailFormList from '~components/pages/teachers/studentDetail/FormList'
import StudentDetailFileUpload from '~components/pages/teachers/studentDetail/FileUpload'
export default {
  name: 'TeachersStudentDetailContent',
  components: {
    StudentDetailFormList,
    StudentDetailFileUpload,
  },
  data () {
    return {
      activeSegment: '學生相關表單',
    }
  },
  computed: {
    ...mapGetters('pages/teachers', [
      'currentTeacherGetter',
      'currentInternRecordListGetter',
    ]),
    subtitle () {
      const curStudent = this.currentInternRecordListGetter.find(record => (
        record.year == this.$route.params.year &&
        record.enterprise_id == this.$route.params.eid &&
        record.student_id == this.$route.params.sid
      ));
      if(!curStudent) return "-";
      return [curStudent.department, curStudent.student_account, curStudent.student_name].join(' ');
    },
  },
  async created () {
    this.togglePageLoader(true);
    await this.getInternRecordList();
    this.togglePageLoader(false);
  },
  methods: {
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    ...mapActions('pages/teachers', [
      'getInternRecordList',
    ]),
  }
}
</script>
<style lang="scss" scoped>
  @media (max-width: 768px) {
    .portlet_wrapper {
      padding: 20px;
    }
    .view_type_select {
      margin-bottom: 30px;
    }
    .cnt_block { padding: 0; }
  }
</style>
